import { ReactComponent as CopyIcon } from '../../../../../assets/icons/copy.svg';
import { ReactComponent as DeleteFillIcon } from '../../../../../assets/icons/delete-new-icon.svg';

export const QUESTION_TITLE_ERROR = 'error_question_title';

export const ANSWER_TITLE_ERROR = 'error_answer_title';

export const TEXT = 'text';

export const DELAY = 400;

export const getQuestionActionItems = (
  labels,
  item,
  onDuplicate,
  onDelete,
  errors
) => [
  ...(!errors
    ? [
        {
          type: 'duplicate',
          label: labels.duplicateLabel,
          action: () => onDuplicate(item),
          shouldItemRender: () => true,
          icon: CopyIcon,
        },
      ]
    : []),
  {
    type: 'delete',
    label: labels.deleteLabel,
    action: () => onDelete(item),
    shouldItemRender: () => true,
    icon: DeleteFillIcon,
  },
];
